
import React, { Component } from 'react';
import { withRouter } from 'react-router';

class AuthLinkClickHandlerHandler extends Component {
    constructor(props) {
        super(props);
        this.handleAuthMode = this.handleAuthMode.bind(this);
    }

    componentDidMount() {
        const query = window.location.search;
        console.log("Query:",query)
        this.mode = new URLSearchParams(query).get('mode');
        this.handleAuthMode(this.mode, query)
    }

    handleAuthMode(mode, query) {
        switch (mode) {
            case "resetPassword":
                this.props.history.push('/reset-password'+query);
                break;
            case "verifyEmail":
            default:
                this.props.history.push('/verify-user-email'+query);
                break;
        }
    }

    render() {
        return null;
    }
}

export default withRouter(AuthLinkClickHandlerHandler);

